/** @jsxImportSource @emotion/react */
import InsightsTableContainer from "components/Insights";
import Layout from "./Layout";

export default function Insights() {
  const PAGE_NAME = "Marvelous Insights";

  const title = `${PAGE_NAME}`;

  return (
    <Layout title={title}>
      <InsightsTableContainer />
    </Layout>
  );
}
